export default __webpack_public_path__ + "static/media/NnamdiEneh.3954ce09.svg";